// extracted by mini-css-extract-plugin
module.exports = {"responsiveVimeo":"VideoVimeo_responsiveVimeo__v6wOF","vimeo":"VideoVimeo_vimeo__3IrDQ","fullHeight":"VideoVimeo_fullHeight__3yb4n","bounce":"VideoVimeo_bounce__2D69D"};